import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { SPA_ROUTES } from './paths';

const DEFAULT_SUFFIX = 'Tobii Dynavox SSO';

const ROUTE_TITLES: Record<string, string> = {
  [SPA_ROUTES.LOGIN]: 'Log_in_to_your_account',
  [SPA_ROUTES.FEDERATED_LOGIN]: 'SsoLogin',
  [SPA_ROUTES.LOGOUT]: 'Logged_out',
  [SPA_ROUTES.FORGOT_PASSWORD]: 'Recover_your_account',
  [SPA_ROUTES.FORGOT_PASSWORD_CONFIRM]: 'Forgot_password_confirmation',
  [SPA_ROUTES.LOCKOUT]: 'account_locked_title',
  [SPA_ROUTES.ACCESS_DENIED]: 'Access_denied',
  [SPA_ROUTES.RESET_PASSWORD]: 'Reset_password',
  [SPA_ROUTES.RESET_PASSWORD_CONFIRM]: 'Success',
  [SPA_ROUTES.PASSWORD_RESET_REQUIRED]: 'Password_reset',
  [SPA_ROUTES.CONFIRM_ACCOUNT]: 'Account_verified',
  [SPA_ROUTES.CONFIRM_ACCOUNT_REQUIRED]: 'Verify_account',
  [SPA_ROUTES.REGISTER]: 'Create_account',
  [SPA_ROUTES.ERROR]: 'Error',
  [SPA_ROUTES.LANGUAGE]: 'Choose_your_language',
  [SPA_ROUTES.BROWSER_UNSUPPORTED]: 'Browser_not_supported',
  [SPA_ROUTES.MANAGE]: 'My_account',
  [SPA_ROUTES.EDIT_PROFILE]: 'Edit_profile',
  [SPA_ROUTES.CHANGE_PASSWORD]: 'Change_password',
  [SPA_ROUTES.SET_PASSWORD]: 'Set_password',
  [SPA_ROUTES.SUPPORT]: 'Support',
  [SPA_ROUTES.SUPPORT_EDIT_ACCOUNT]: 'Edit Account',
};

type UseDocumentTitleOpts = {
  suffix?: string | false;
  vars?: Record<string, unknown>;
};

// Generic hook for pages that want to set title themselves
export function useDocumentTitle(i18nKey?: string, opts: UseDocumentTitleOpts = {}) {
  const { t, i18n } = useTranslation();

  useEffect(() => {
    if (!i18nKey) return;
    const base = t(i18nKey, opts.vars);
    const suffix = opts.suffix === false ? '' : (opts.suffix ?? DEFAULT_SUFFIX);
    const full = suffix ? `${base} – ${suffix}` : base;
    document.title = full;
  }, [i18nKey, opts.suffix, i18n.language, t, opts.vars]);
}

export function RouteTitleSync({ suffix }: { suffix?: string }) {
  const { pathname } = useLocation();
  const { t, i18n } = useTranslation();

  useEffect(() => {
    const key = ROUTE_TITLES[pathname];
    if (!key) return;

    const base = t(key);
    document.title = suffix ? `${base} – ${suffix}` : base;
  }, [pathname, i18n.language, suffix, t]);

  return null;
}
